export function loadAudio(src, volume=1) {

    const audio = new Audio(src)
    audio.volume = volume

    return audio
}
